<template>
  <div class="login">
    <div class="wrapper">
      <img class="logo" src="../../assets/images/logo.png" />
      <h4 class="title">密码登录</h4>
      <div class="form">
        <el-form ref="form" :rules="rules" :model="formModel" @submit.native.prevent>
          <el-form-item prop="username">
            <el-input v-model="formModel.username" placeholder="请输入魔欢教师账号"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" v-model="formModel.password" placeholder="请输入密码" show-password></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" native-type="submit" @click="handleSubmit" class="form-submit" :loading="submitLoading">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
      <img src="../../assets/images/login-bg.png" class="bottom">
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { queryToken } from '@/services'
export default {
  name: 'Login',
  data () {
    return {
      formModel: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '请输入魔欢教师账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      submitLoading: false
    }
  },
  methods: {
    handleSubmit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.userLogin(valid)
        } else {
          return false
        }
      })
    },
    userLogin () {
      this.submitLoading = true
      queryToken({
        account: this.formModel.username,
        password: this.formModel.password
      }).then(res => {
        localStorage.setItem('token', res.access_token)
        this.changeToken(res.access_token)
        this.submitLoading = false
        const redirectTarget = this.$route.query.redirect
        if (redirectTarget) {
          this.$router.push({
            path: redirectTarget
          })
        } else {
          this.$alert('登录成功，请重新打开页面')
        }
      }).catch(errpr => {
        this.submitLoading = false
      })
    },
    ...mapMutations(['changeToken'])
  }
}
</script>

<style lang="scss" scoped>
.login {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f0f0f0;
  .title {
    font-size: 16px;
    color: #333;
    text-align: center;
  }
  .wrapper {
    background-color: #ffffff;
    width: 460px;
    box-shadow: 0 0 30px rgba(0,0,0,.1);
    padding: 35px 0 120px 0;
    border-radius: 20px;
    position: relative;
  }
  .logo {
    display: block;
    margin: 0 auto;
  }
  h4 {
    font-weight: normal;
    font-size: 18px;
    margin: 28px 0 0;
  }
  .bottom {
    display: block;
    width: 100%;
    bottom: 0;
    left: 0;
    position: absolute;
  }
  .form {
    width: 340px;
    margin: 40px auto 0;
  }
  .form-submit {
    width: 100%;
  }
}
</style>
